import CRMPermission from '@/models/enums/permissions/CRMPermission'
import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/settings/review-actions',
    name: RouteName.SettingsReviewActions,
    component: () => import('@/pages/Settings/ReviewActions.vue'),
    meta: {
      permissions: [CRMPermission.ReviewActions],
      breadcrumb: {
        label: 'Внешние сервисы для отзывов',
        parent: RouteName.Settings,
      },
    },
  },
]
